import { useLocation } from "react-router-dom";
import OTPForm from "../../components/Auth/OTPForm";
import { useLanguage } from "../../components/LanguageProvider/LanguageProvider";
import AuthLayout from "../../components/Layout/AuthLayout";

const Otp = () => {
  const { language, setLanguage } = useLanguage();
  const location = useLocation();   // ⭐ REQUIRED
  const cafId = location.state?.cafId;

  return (
    <AuthLayout
      title={language ? "ओटीपी भरें" : "Enter OTP"}
      showLanguageToggle={true}
    >
      <OTPForm cafId={cafId} />
    </AuthLayout>
  );
};

export default Otp;
